module.exports = "/images/vendor/flag-icon-css/flags/4x3/lt.svg?c3aeac0dad1dfcc917a721a975ea29dd";